import { Component, Host, h, Prop } from '@stencil/core';
import { metrics } from '../../utils';
import type { Typography, Alpha, HtmlTags } from '../../utils/types/index';

/**
 *  @cssprop --line-height - inherit;
 *  @cssprop --padding Padding
 *  @cssprop --margin Margin
 *  @cssprop --max - auto;
 *  @slot - Default Text Content
 */
@Component({
  tag: 'prism-text',
  styleUrl: 'prism-text.css',
  shadow: true,
})
export class Text {
  /** tag: Renders a html tag */
  @Prop() tag: HtmlTags = 'p';
  /** display: Defined Sizes */
  @Prop() display: Typography = 'body2';
  /** Apply [...] to the content */
  @Prop() ellipsis: boolean = false;
  /** Text Priority: Alpha */
  @Prop() priority: Alpha = 'primary';
  /** Expressive: Adds a gradient (if available) to the text */
  @Prop() expressive?: boolean = false;
  connectedCallback() {
    // Component Data Layer
    metrics('prism-text');
  }
  render() {
    const CustomTag = this.tag;
    return (
      <Host class={{ ['text-block']: this.tag !== 'span', [this.display]: true }}>
        <CustomTag
          class={{
            text: true,
            [this.priority]: true,
            ellipsis: this.ellipsis,
            expressive: this.expressive,
          }}
        >
          <slot></slot>
        </CustomTag>
      </Host>
    );
  }
}
